<!--suppress ALL -->
<template>
  <div>
    <div
      :style="getColor"
      :class="{'setColor':getScroll > windowHeightw}"
      :height="height"
      class="mt-header">
      <el-row>
        <el-col
          :xs="19"
          :sm="14"
          :md="16"
          :lg="17"
          :xl="19"
          class="logo hidden-xs-only">
          <router-link :to="{name: 'Home'}">
            <img
              :class="{'changeHeight': getScroll >= windowHeightw}"
              :style="heightLogo"
              src="@/assets/images/logoW.svg">
          </router-link>
        </el-col>
        <el-col
          :xs="3"
          :sm="6"
          :md="8"
          :lg="8"
          :xl="8"
          :class="{'setHeight':getScroll >= windowHeightw}"
          class="logo  hidden-sm-and-up">
          <router-link :to="{name: 'Home'}">
            <img
              src="@/assets/images/logoMT_white.svg">
          </router-link>
        </el-col>
        <el-col
          v-if="tokenLength === 0"
          :xs="6"
          :sm="8"
          :md="6"
          :lg="6"
          :xl="4"
          class="btn hidden-xs-only">
          <div>
            <el-button
              type="text"
              @click="openSignIn">Iniciar sesión
            </el-button>
          </div>
          <div>
            <el-button
              type="text"
              class="register-btn"
              @click="openCreateAccount">Crear cuenta
            </el-button>
          </div>
        </el-col>
        <el-col
          v-else
          :xs="6"
          :sm="7"
          :md="6"
          :lg="6"
          :xl="4"
          class="btn hidden-xs-only">
          <div>
            <el-button
              type="text"
              @click="goToMyProfile">Mi cuenta
            </el-button>
          </div>
        </el-col>
        <el-col
          :xs="18"
          :sm="2"
          :md="2"
          :lg="2"
          :xl="2"
          class="hidden-sm-and-up icon-searchw">
          <el-input
            placeholder="Buscar un evento, artista o lugar">
            <i
              slot="prefix"
              class="icon-search"/>
          </el-input>
          <!-- <i
            class="icon-search-icon"
            @click="showSearch"/>-->
        </el-col>
        <el-col
          :xs="3"
          :sm="2"
          :md="2"
          :lg="1"
          :xl="1"
          class="icon-menuw">
          <i
            class="icon-menu"
            @click="showMenu"/>
        </el-col>
      </el-row>
    </div>
    <!--LOGIN-->
    <auth-box
      ref="modal">
      <auth-sign-in/>
    </auth-box>
    <!--CREATE ACCOUNT-->
    <auth-box
      ref="modalaccount">
      <auth-register/>
    </auth-box>
    <!--MENU-->
    <menu-home
      v-if="windowWidth > 516"
      v-show="showMenuw"
      ref="show"/>
    <menu-responsive
      v-else
      ref="show"/>
    <!--SEARCH-->
    <transition name="">
      <el-container
        v-show="showSearchw"
        class="search">
        <el-row>
          <el-col
            :span="24"
            class="input-search-responsive">
            <el-input
              placeholder="Buscar evento, artista o lugar">
              <i
                slot="prefix"
                class="icon-left-arrow"
                @click="showSearch"/>
            </el-input>
          </el-col>
          <el-col
            :span="24"
            class="recent-search">
            Búsquedas recientes
          </el-col>
        </el-row>
      </el-container>
    </transition>
  </div>
</template>

<script>
import AuthBox from '../auth/auth-box'
import AuthSignIn from '../auth/auth-sign-in'
import AuthRegister from '../auth/auth-register'
import menuHome from '../menu/menu-home'
import menuResponsive from '../menu/menu-responsive'
import auth from '@/services/auth.service'
export default {
  name: 'NavBar',
  components: {AuthSignIn, AuthRegister, menuHome, menuResponsive, AuthBox},
  data () {
    return {
      positionTop: true,
      showSearchw: false,
      windowWidth: 0,
      windowHeightw: 0,
      getScroll: 0,
      showMenuw: false,
      height: '70px',
      register: false,
      login: 'none',
      token: '',
      tokenLength: 0
    }
  },
  computed: {
    getColor () {
      return {
        backgroundColor: this.$route.meta.colorHeader,
        top: this.$route.meta.top + '!important',
        position: this.$route.meta.position
      }
    },
    heightLogo () {
      return {
        height: this.$route.meta.height + 'px !important'
      }
    }
  },
  mounted () {
    this.token = auth.token()
    if (this.token != null) {
      this.tokenLength = this.token.length
    }

    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
      /// ///////////////////////////////////////////////////////
      window.addEventListener('scroll', this.getHandleScroll)
      this.getHandleScroll()
    })
    if (this.$route.name === 'register') {
      this.$refs.modalaccount.open()
    }
    if (this.$route.name === 'sign-in') {
      this.$refs.modal.open()
    }
  },
  methods: {
    goToSearch () {
      this.$router.push('search')
    },
    goToHome () {
      this.$router.push({name: 'Home'})
      this.seen = false
    },
    /// ////GET PIXEL WIDTH/////////
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight () {
      this.windowHeightw = document.documentElement.clientHeight
    },
    /// ////GET SCROLL/////////
    getHandleScroll () {
      this.getScroll = window.scrollY
    },
    /// //////OPEN MODAL SIGN IN///////////
    openSignIn () {
      /* this.$store.dispatch('blockOverflow', true) */
      this.$refs.modal.open()
      // this.$router.push({name: 'sign-in'})
    },
    openCreateAccount () {
      this.$refs.modalaccount.open()
      // this.$router.push({name: 'register'})
    },
    /// //////SHOW MENU///////////
    showMenu () {
      // this.showMenuw = !this.showMenuw
      this.$refs.show.open()
    },
    goToMyProfile () {
      this.$router.push({path: 'my_account'})
    },
    /// //////SHOW SEARCH ///////
    showSearch () {
      this.showSearchw = !this.showSearchw
    }
  }
}
</script>

<style lang="scss" scoped>

   .setPosition {
    top: 75px !important;
   }
   .setColor{
      background-color: $roseHeader !important;
      top: 0 !important;
      position: fixed !important;
    }
   .changeHeight{
     height: 30px !important;
   }

   .mt-header {
    background-color: transparent;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 200;
    padding: 0 80px;
     @media #{$Laptop} {
       padding: 0 50px;
     }
    @media #{$iPad} {
      padding: 0 40px;
      top: 75px;
    }
     @media #{$iPhoneLandscape}{
       padding: 0 30px;
       position: fixed !important;
       top: 0;
       background-color: $roseHeader;
     }
     @media #{$iPhone} {
       padding: 0 10px;
     }
     @media #{$iPhoneSE} {
       max-width: 320px;
     }
    .logo {
      img{
        height: 40px;
        @media #{$Laptop} {
          height: 30px !important;
        }
        @media #{$iPad} {
          height: 30px;
        }
        @media #{$Note} {
          height: 25px;
        }
      }
    }
    .el-row {
      height: 70px !important;
      margin: 0 !important;
      @media #{$Elementxs}{
        height: 50px !important;
      }
    }

    .el-col {
      height: 70px !important;
      display: flex;
      align-items: center;
      @media #{$Elementxs}{
        height: 50px !important;
      }
    }
  }
.logoHidden{
  visibility: hidden;
}
  .btn{
    display: flex;
    justify-content: flex-end;
    div{
      width: 50%;
      text-align: right;
    }
    button{
      background-color: transparent;
      @include font-primary(14px, bold);
      color: #F9D9DE;
      border: none !important;
      border-radius: 2px;
      white-space: normal;
      border: 1px solid white;
      padding: 0;
      &:hover{
        color: white;
      }
    }
    .register-btn{
      @media #{$Laptop} {
        padding-right: 10px;
      }
    }
  }

  .icon-menuw {
    color: white;
    cursor: pointer;
    text-align: right;
    visibility: hidden;
    i {
      width: 100%;
      font-size: 24px;
      @media #{$Elementxs} {
        font-size: 32px;
        visibility: visible;
      }
      @media #{$Note} {
        font-size: 24px;
      }
      @media #{$iPhoneSE} {
        font-size: 22px;
      }
      &:active {
        color: white;
      }
    }
  }
  ///////////MENU/////////////////

   .slide-fade-enter-active {
     transition: all .3s ease;
   }

   .slide-fade-leave-active {
     transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
   }

   .slide-fade-enter, .slide-fade-leave-to
     /* .slide-fade-leave-active below version 2.1.8 */
   {
     transform: translateX(10px);
     opacity: 0;
   }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue